let CustomDonationField = class extends HTMLElement
{
   constructor()
   {
      super();
   }

   connectedCallback()
   {
      const qty_input = this.querySelector('.custom-donation--qty');
      const send_button = this.querySelector('.custom-donation--button');
      qty_input.addEventListener('input', this.onInput.bind(this));
      send_button.addEventListener('click', this.onSend.bind(this));
   }

   disconnectedCallback()
   {
      const qty_input = this.querySelector('.custom-donation--qty');
      const send_button = this.querySelector('.custom-donation--button');
      qty_input.removeEventListener('input', this.onInput.bind(this));
      send_button.removeEventListener('click', this.onSend.bind(this));
   }

   onInput = (event) =>
   {
      const value = event.target.value;
      if (isNaN(value) || value < 1)
      {
         event.target.value = 1;
      }
   }

   onSend = (event) =>
   {
      const qty_input = this.querySelector('.custom-donation--qty');
      const send_button = this.querySelector('.custom-donation--button');
      const variant_id = send_button.getAttribute('data-variant-id');
      const qty = qty_input.value;
      const form = document.createElement('form');
      const permalink = `/cart/${variant_id}:${qty}?checkout`;
      window.location.href = permalink;
   }
}

if (!window.customElements.get("custom-donation"))
{
   window.customElements.define("custom-donation", CustomDonationField);
}